import axios from "axios";
import baseURL from "./baseUrl";
import { getClientIp } from "./loadClientIp";

const unAuthAxios = axios.create({
    baseURL: baseURL
});
unAuthAxios.interceptors.request.use((config) => {
    const ip = getClientIp();

    if (ip) {
        config.headers["X-Forwarded-For"] = ip;
    }

    return config;
});
export default unAuthAxios;